import { UncontrolledTooltip } from 'reactstrap';
import { isEmpty } from 'lodash-es';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheck, faQuestionCircle } from '@fortawesome/free-solid-svg-icons';
import Chip from '../../../../common/forms/Chip';

export const ResourceChip = ({ ...resource }) => {
    if (resource.isSelected) {
        return (
            <Chip
                color="success"
                className="text-uppercase mr-2"
                icon={(
                    <FontAwesomeIcon icon={faCheck} />
                )}
                outlined
            />
        );
    }

    if (resource.recommended) {
        return (
            <Chip
                color="success"
                className="text-uppercase mr-2"
                outlined
            />
        );
    }

    if (resource.linkedEmployee) {
        const tooltips = [];

        const { linkedEmployee } = resource;

        if (linkedEmployee.employeeAlreadyAssigned) {
            tooltips.push('Employee is already assigned to a job at this time');
        }

        if (linkedEmployee.employeeExcludedDispatch) {
            tooltips.push('Employee is excluded from dispatch.');
        }

        if (linkedEmployee.employeeInactive) {
            tooltips.push('Employee is marked inactive.');
        }

        if (linkedEmployee.employeeInDAE) {
            tooltips.push('Employee has a non-dispatchable daily attendance event.');
        }

        if (linkedEmployee.employeeInLTS) {
            tooltips.push('Employee has a non-dispatchable long term status.');
        }

        if (linkedEmployee.employeeNotInGroup) {
            tooltips.push('Employee is not in a group needed by the job.');
        }

        if (linkedEmployee.employeeRestrictedCompany) {
            tooltips.push('Employee is restricted from the company or foreman.');
        }

        if (linkedEmployee.employeeExcludedEmployee) {
            tooltips.push('Employee is restricted from another assigned employee.');
        }

        if (linkedEmployee.employeeExcludedTime) {
            tooltips.push('Employee is restricted from working the selected job time.');
        }

        if (!isEmpty(tooltips)) {
            return (
                <>
                    <Chip
                        id={`resource-${resource.id}`}
                        color="danger"
                        className="text-uppercase mr-2"
                        text={(
                            <>
                                <span>Invalid Employee</span>
                                <FontAwesomeIcon
                                    icon={faQuestionCircle}
                                    className="ml-1"
                                />
                            </>
                        )}
                        outlined
                    />

                    <UncontrolledTooltip
                        target={`resource-${resource.id}`}
                        className="tooltip-width-auto"
                    >
                        {tooltips.map((tip) => (
                            <div
                                key={tip}
                                className="text-nowrap"
                            >
                                {tip}
                            </div>
                        ))}
                    </UncontrolledTooltip>
                </>
            );
        }
    }

    if (resource.percentToOvertimeThreshold > 1) {
        return (
            <Chip
                color="danger"
                className="text-uppercase mr-2"
                text="In Overtime"
                outlined
            />
        );
    }

    if (resource.percentToOvertimeThreshold > 0.8) {
        return (
            <Chip
                color="warning"
                className="text-uppercase mr-2"
                text="Near Overtime"
                outlined
            />
        );
    }

    if (resource.numAssignmentsToday) {
        if (resource.numAssignmentsToday > 1) {
            return (
                <Chip
                    color="danger"
                    className="text-uppercase mr-2"
                    text={`${resource.numAssignmentsToday} assignments`}
                    outlined
                />
            );
        }

        return (
            <Chip
                color="info"
                className="text-uppercase mr-2"
                text="Assigned Today"
                outlined
            />
        );
    }

    return null;
};